import type { MockDB, MockUser } from "./db";

const SESSION_KEY = "ocp.mock.session";

export const DEMO_ACCOUNTS: Record<string, string[]> = {
  "13800000001": ["registered_user"],
  "13800000002": ["registered_user", "merchant"],
  "13800000003": ["registered_user", "park_reviewer"],
  "13800000004": ["registered_user", "park_admin"],
  "13800000005": ["registered_user", "super_admin"],
};

export function currentUser(db: MockDB): MockUser | undefined {
  const id = sessionStorage.getItem(SESSION_KEY);
  return db.users.find((user) => user.id === id && user.status === "active");
}

export function login(db: MockDB, phone: string): MockUser {
  let user = db.users.find((item) => item.phone === phone);
  if (!user) {
    db.sequence += 1;
    user = {
      id: `user-${db.sequence}`,
      phone,
      phone_masked: `${phone.slice(0, 3)}****${phone.slice(-4)}`,
      nickname: `新用户${phone.slice(-4)}`,
      roles: ["registered_user"],
      status: "active",
      created_at: new Date().toISOString(),
    };
    db.users.push(user);
  }
  if (user.status !== "active") throw new Error("账号当前不可登录，请使用 ?mock-reset=1 重置演示数据");
  sessionStorage.setItem(SESSION_KEY, user.id);
  user.last_login_at = new Date().toISOString();
  return user;
}

export function clearSession() {
  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem("opc.csrf");
}

export function requireUser(db: MockDB): MockUser {
  const user = currentUser(db);
  if (!user) throw new Error("请先登录");
  return user;
}
